var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddActiveMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 5.35v5.3H18a1.35 1.35 0 1 1 0 2.7h-5.3v5.3a1.35 1.35 0 1 1-2.7 0v-5.3H4.7a1.35 1.35 0 1 1 0-2.7H10v-5.3a1.35 1.35 0 0 1 2.7 0z",
    fill: "#2D6CE6",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddActiveMedium);
export default __webpack_public_path__ + "static/media/add-active-medium.73be4b4dbb984787c6e1814ade2d0474.svg";
export { ForwardRef as ReactComponent };